import { z } from '@bonanza-social/toolkit/api';

const StatusesSchema = z.object({
  name: z.string(),
  maxDaysToComplete: z.number().optional(),
  keepStatusBoxCount: z.number().optional(),
  promotionBoxCount: z.number().optional(),
});

export const StatusConfigResponseSchema = z.object({
  boxAutoRewardDays: z.number().optional(),
  statuses: z.array(StatusesSchema).optional(),
});
